module.exports = __webpack_public_path__ + "media/charSelectMusic.2958082d.ogg";